namespace appn.log {

    let _loggingEnabled = false;

    export function init() {

        if (appn.isDebug) {
            _loggingEnabled = true;
            return;
        }

        const enabledFromLs = appn.localStorage.getItem('loggingEnabled');
        _loggingEnabled = enabledFromLs ? true : false;
    }

    enum LogLevel {
        Info,
        Warning,
        Error,
        Debug
    }

    function log(message: any, logLevel?: LogLevel) {
        if (!_loggingEnabled)
            return;

        // Do stuff before

        switch (logLevel) {
            case LogLevel.Info: {
                console.log(message);
                break;
            }
            case LogLevel.Warning: {
                console.warn(message);
                break;
            }
            case LogLevel.Error: {
                console.error(message);
                break;
            }
            case LogLevel.Debug: {
                console.debug(message);
                break;
            }
        }

        // Do stuff after
    }

    export function info(message: any, includeCallStack?: boolean) {
        log(message, LogLevel.Info);

        if (includeCallStack)
            appn.log.debug(new Error().stack);
    }

    export function warning(message: any, includeCallStack?: boolean) {
        log(message, LogLevel.Warning);

        if (includeCallStack)
            appn.log.debug(new Error().stack);
    }

    export function error(message: any, includeCallStack?: boolean) {
        log(message, LogLevel.Error);

        if (includeCallStack)
            appn.log.debug(new Error().stack);
    }

    export function debug(message: any, includeCallStack?: boolean) {
        log(message, LogLevel.Debug);

        if (includeCallStack)
            appn.log.debug(new Error().stack);
    }

    export class PerfTimer {
        time0: number = 0;
        time1: number = 0;
        title: string = appn.emptyString;

        constructor(title: string) {
            this.title = title;
        }

        start(): void {
            this.time0 = performance.now();
        }

        stop(): string {
            this.time1 = performance.now();
            const timeDelta = (this.time1 - this.time0);
            const message = `${this.title}: ${timeDelta.toFixed(5)} ms`;
            appn.log.info(message);
            return message;
        }
    }

}
